import React, { useState } from "react"
import TextInput from "../components/commons/TextInput"
import Button from "../components/commons/Button"
import { Link, useNavigate } from "react-router-dom"
import { useAuth } from "../context/authContext"
import { toast } from 'react-toastify';
import { getUserData, createUserProfile } from "../firebase/users"

const Login = () => {
  const { login, loginWithGoogle, resetPassword, getUpdatedUserData, setUserData } = useAuth()
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const navigate = useNavigate()

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };


  const handleGoogleSignin = async () => {
    try {
      await loginWithGoogle()

      toast.success("Successfully logged in!");

      const intervalId = setInterval(async () => {
        await getUpdatedUserData()
        const storedUserData = localStorage.getItem('userData')
        const data = JSON.parse(storedUserData)

        if (data && data.balance !== undefined) {
          navigate('/')
          clearInterval(intervalId)
        }
      }, 2000);
    } catch (error) {
      console.log(error.code)
    }
  }

  const handleSubmit = async () => {
    try {
      const userCredential = await login(email, password)
      const user = userCredential.user

      if (user.emailVerified) {
        await createUserProfile(user.uid, email)
        const data = await getUserData(user.uid)

        const storedUserData = { ...data, id: user.uid }
        localStorage.setItem('userData', JSON.stringify(storedUserData))

        if (data.role === 'admin') {
          toast.success("Successfully logged in!");
          setUserData(storedUserData)
          navigate("/")
        }
        else if(data.role === 'sub-admin') {
          toast.success("Successfully logged in!");
          setUserData(storedUserData)
          navigate("/")
        }
        else {
          toast.error("This user is not admin.")
        }
      } else {
        toast.warn("Please verify your email")
      }
    } catch (error) {
      console.log(error);
      if (error.code === "auth/invalid-credential") {
        toast.error("The credential is invalid. Please try again.")
      }

      if (error.code === "auth/invalid-email") {
        toast.error("The email address is not valid. Please enter a valid email.")
      }

      if (error.code === "auth/weak-password") {
        toast.error("The password is too weak. Please choose a stronger password.")
      }
    }
  }

  const handleResetPassword = async () => {
    if (!email) return alert("Please enter your email")
    if (!validateEmail(email)) {
      toast.error("Please enter a valid email address")
      return
    }
    try {
      await resetPassword(email)
      toast.success("Password reset email sent");
    } catch (error) {
      console.log(error.message)
    }
  }

  return (
    <div
      className="container h-screen mx-auto p-5"
      style={{
        background: "url('/assets/backgrounds/footer_background.png')",
        backgroundSize: "100% 100%",
      }}
    >
      <div className="flex flex-col lg:flex-row items-center justify-center lg:justify-between h-full gap-8">
        <div className="flex w-full flex-col items-center relative  after:content-[''] after:h-full after:top-0 after:absolute after:w-full after:hidden lg:after:block lg:after:max-w-[400px] after:bg-[linear-gradient(to_left,#141414_0%,#14141400_100%)] after:right-0  after:pointer-events-none  before:content-['']  before:absolute before:h-full before:w-full before:max-w-[100px] lg:before:max-w-[400px] before:hidden lg:before:block before:left-0 before:bg-[linear-gradient(to_left,#14141400_0%,#141414_100%)] z-10 before:z-20  before:pointer-events-none">
          <h1 className="text-white font-aero text-center text-[32px] lg:text-[48px] uppercase  leading-[1.2]">
            <span className="text-primary font-aero">login</span> and <br /> get
            started
          </h1>
          <div className="">
            <div className="hidden lg:flex items-center my-12 gap-8 py-6 relative after:content-[''] after:w-[200px] after:h-[300px] after:left-[50%] after:translate-x-[-50%] after:bottom-[50%] after:translate-y-[50%] after:blur-[80px] after:bg-primary after:rounded-full after:absolute after:z-[-1]">
              <img
                src="/assets/decorations/auth_decoration_1.png"
                className="max-w-[160px]"
              />
              <img
                src="/assets/decorations/auth_decoration_2.png"
                className="max-w-[240px]"
              />
              <img
                src="/assets/decorations/auth_decoration_3.png"
                className="max-w-[160px]"
              />
            </div>
          </div>
          <img
            className="w-full max-w-[180px] hidden lg:block"
            src="/assets/logos/logo.svg"
            alt=""
          />
        </div>
        <div className="w-full max-w-[500px] lg:mr-8  relative after:content-[''] after:w-[360px] after:left-[100%] after:h-[360px] after:bottom-[90%] after:blur-[200px] after:bg-primary after:rounded-full after:absolute after:z-[1]">
          <div className="border-style-decoration text-white product-ask-section p-7 lg:p-10 bg-white/5 backdrop-blur-md w-full">
            <label className="w-full">
              <span className="mb-3 block">Email address</span>
              <TextInput
                value={email} 
                placeholder="Enter email address"
                inputClassName="placeholder:text-white/60"
                divClassName="border-style-decoration rounded-none"
                onChange={(value) => { setEmail(value) }}
              />
            </label>
            <div className="w-full mt-8">
              <label className="w-full">
                <span className="mb-3 block">Password</span>
                <TextInput
                  value={password}
                  placeholder="Enter password"
                  inputClassName="placeholder:text-white/60"
                  divClassName="border-style-decoration rounded-none"
                  defaultType="password"
                  endIcon={<img src="/assets/icons/icon-eye-slash.svg" />}
                  onChange={(value) => { setPassword(value) }}
                />
              </label>
            </div>
            <Button onClick={handleSubmit}
              divClassName="w-full border-style-decoration-container mt-14"
              buttonClassName="border-style-decoration"
              isActive
            >
              Login
            </Button>

            <div className="flex items-center justify-center mt-10">
              <span>Forgot Password? </span>
              <button className="text-primary w-fit ml-3 flex" onClick={handleResetPassword}>
                Reset Password
              </button>
            </div>
          </div>
        </div>
        <img
          className="w-full max-w-[180px]  lg:hidden"
          src="/assets/logos/logo.svg"
          alt=""
        />
      </div>
    </div>
  )
}

export default Login
